import React, { useState } from "react";
import Layout from "../../Layout";
import "./style.scss";
import SEO from "../../seo";

export default function Techvaganza25Page() {
  // Track active tabs for each competition panel
  const [activeTabs, setActiveTabs] = useState({
    digital: "topics",
    pixel: "topics",
    scratch: "topics",
    vocal: "topics",
    slide: "topics",
  });

  // Handle tab changes for each competition
  const handleTabChange = (compId, tabId) => {
    setActiveTabs((prev) => ({
      ...prev,
      [compId]: tabId,
    }));
  };

  // Competition data
  const competitions = [
    {
      id: "digital",
      title: "DIGITAL DREAMSCAPE",
      subtitle: "Movie Making",
      classGroup: "XI-XII",
      participants: "05",
      entries: "01",
      description:
        "Participants will have the chance to showcase their storytelling skills through multimedia tools and creative illustrations, direct their unique vision, and bring captivating narratives to life.",
      topics: ["Imbibing Positive Emotions", "Civic Consciousness"],
      criteria: ["Creativity and originality", "Technical Execution (Cinematics, Editing and Sound quality)", "Emotional impact", "Relevance with topic"],
      details: [
        "Movie should not be longer than 4 minutes.",
        "File must be in the format of SchoolName_EventName.",
        "Teacher In-charge to make sure that the submission must not include any inappropriate and obscene content, this will lead to disqualify the entry.",
        "The entries should be sent to the host school by Saturday, 10-05-2025 using the submission link.",
      ],
    },
    {
      id: "pixel",
      title: "PIXEL PRODIGY",
      subtitle: "Photography",
      classGroup: "IX-X",
      participants: "02",
      entries: "01",
      description: "Participants will have to capture the photograph on the given topic to display their unique prospective and vision.",
      topics: ["Capture Motion", "Miniature in Nature"],
      criteria: ["Creativity and Originality", "Framing and Viewpoint", "Message conveyed as per theme"],
      details: [
        "File should be in original format.",
        "File must be in the format of SchoolName_EventName.",
        "The entries should be sent to the host school by Saturday, 10-05-2025 using the submission link.",
      ],
    },
    {
      id: "scratch",
      title: "SCRATCH-IN",
      subtitle: "Scratch",
      classGroup: "VI-VII",
      participants: "02",
      entries: "01",
      description: "Participants are required to create a short self-written story on the topic given of their choiceusing Scratch 3.0.",
      topics: ["Holiday Adventures", "Environment Awareness"],
      criteria: ["Originality", "Creativity", "Relevance with topic", "Visual and audio effects"],
      details: [
        "File must be submitted in their original format of Scratch 3.0.",
        "File should not be longer than 3 minutes.",
        "File must be in the format of SchoolName_EventName.",
        "The entries should be sent to the host school by Saturday, 10-05-2025 using the submission link.",
      ],
    },
    {
      id: "vocal",
      title: "VOCAL VISIONARIES",
      subtitle: "Podcast",
      classGroup: "X-XII",
      participants: "02",
      entries: "01",
      description: "Participants will share their unique perspectives and creative interactive podcast on the given topic through audio and video.",
      topics: ["Cryptocurrency: The New Future", "E-Gaming: As a career"],
      criteria: ["Content Quality", "Creativity and Originality", "Technical Execution (Editing and Sound quality)"],
      details: [
        "Max length: 3 mins, format MP4 or MOV only.",
        "Any kind of Explicit Content or inappropriate content will lead to disqualification.",
        "File must be in the format of SchoolName_EventName.",
        "The entries should be sent to the host school by Saturday, 10-05-2025 using the submission link.",
      ],
    },
    {
      id: "slide",
      title: "SLIDE SAFARI",
      subtitle: "Presentation",
      classGroup: "VII-VIII",
      participants: "02",
      entries: "01",
      description:
        "Participants will have the opportunity to design and present slides on any one of the giventopics and highlighting their proficiency in presentation tools and techniques.",
      topics: ["Biometrics: Fear the Future", "IoT: An impact on our lives"],
      criteria: ["Creativity & Originality", "Use of presentation tools", "Overall presentation", "Relevance with the topic"],
      details: [
        "File to be submitted in original format of the software used.",
        "The presentation should not be more than 8 Slides.",
        "Participants can use any software like MS PowerPoint or Canva.",
        "File must be in the format of SchoolName_EventName.",
        "The entries should be sent to the host school by Saturday, 10-05-2025 using the submission link.",
      ],
    },
  ];

  return (
    <Layout>
      <SEO
        title="Techvaganza 2025 | Chinmaya Vidyalaya Vasant Vihar"
        description="Techvaganza 2025"
        img="https://chinmayavvdelhi.ac.in/images/Blackele/Chinmaya_link_preview.jpg"
        keywords="techvaganza, tech fest, chinmaya vidyalaya"
      />
      <div className="techvaganza">
        <div className="container">
          <h1 className="text-center">TECHVAGANZA: CV'25</h1>
          <p className="text-center event-description">INTERSCHOOL IT-FEST</p>
          {/* Top Register Button */}
          <div className="top-register-container">
            <a href="/techvaganza-25-results/" className="top-register-btn" target="_blank" rel="noopener noreferrer">
              Winners
            </a>
            {/*  <a href="https://forms.office.com/r/5kbpzeWgJq" className="top-register-btn" target="_blank" rel="noopener noreferrer">
              Register Now
            </a> */}
          </div>
          {/* Panels Container */}
          <div className="panels-container">
            {/* Guidelines Panel */}
            <div className="competition-panel guidelines-panel">
              <div className="panel-header">
                <h3>General Guidelines</h3>
              </div>
              <div className="comp-content">
                <div className="guidelines-content">
                  <ol className="guidelines-list">
                    <li>This IT-Fest is open for the students of classes VI-XII.</li>
                    <li>One student can participate in only ONE of the given events.</li>
                    <li>Teacher in-charges (only) to join WhatsApp group using the link.</li>
                    <li>Participants are requested to ensure that the registration details provided should be correct.</li>
                    <li>Please adhere to the guidelines and number of participants specified for each event.</li>
                    <li>The decision of the judges will be final and binding.</li>
                    <li>The Vidyalaya holds the right to disqualify any team for using any unfair means.</li>
                    <li>Registration link will remain open till 5th, May 2025.</li>
                    <li>Submission of all the entries should be uploaded by 15th, May 2025.</li>
                    <li>Results will be declared by 3rd, June 2025.</li>
                  </ol>

                  <div className="guidelines-dates">
                    <table className="dates-table">
                      <thead>
                        <tr>
                          <th>Event</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Registration Deadline</td>
                          <td>5 May, 2025</td>
                        </tr>
                        <tr>
                          <td>Submission Deadline</td>
                          <td>15 May, 2025</td>
                        </tr>
                        <tr>
                          <td>Results Declaration</td>
                          <td>By 3rd June, 2025</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="comp-buttons">
                {/*   <a href="https://forms.office.com/r/5kbpzeWgJq" className="register-button" target="_blank" rel="noopener noreferrer">
                  Register Now
                </a>
 */}
                <a href="https://chat.whatsapp.com/EpHthYp5Ewc3N6qkNOQJ2T" className="register-button" target="_blank" rel="noopener noreferrer">
                  Join WhatsApp Group (Teacher Incharges Only)
                </a>
              </div>
            </div>

            {/* Competition Panels */}
            {competitions.map((comp) => (
              <div className="competition-panel" key={comp.id}>
                <div className="panel-header">
                  <h3>{comp.title}</h3>
                  <div className="subtitle">{comp.subtitle}</div>
                </div>

                <div className="comp-details">
                  <div className="comp-details-columns">
                    <div className="detail-column">
                      <div className="detail-label">Class Group</div>
                      <div className="detail-value">{comp.classGroup}</div>
                    </div>
                    <div className="detail-column">
                      <div className="detail-label">Participants</div>
                      <div className="detail-value">{comp.participants}</div>
                    </div>
                    <div className="detail-column">
                      <div className="detail-label">Entries per School</div>
                      <div className="detail-value">{comp.entries}</div>
                    </div>
                  </div>
                </div>

                <div className="comp-content">
                  <p>{comp.description}</p>

                  {/* Content Tabs */}
                  <div className="comp-tabs">
                    <div className="comp-tab-buttons">
                      <button
                        className={`comp-tab-button ${activeTabs[comp.id] === "topics" ? "active" : ""}`}
                        onClick={() => handleTabChange(comp.id, "topics")}
                      >
                        Topics
                      </button>
                      <button
                        className={`comp-tab-button ${activeTabs[comp.id] === "criteria" ? "active" : ""}`}
                        onClick={() => handleTabChange(comp.id, "criteria")}
                      >
                        Judgment Criteria
                      </button>
                      <button
                        className={`comp-tab-button ${activeTabs[comp.id] === "details" ? "active" : ""}`}
                        onClick={() => handleTabChange(comp.id, "details")}
                      >
                        Details
                      </button>
                    </div>

                    <div className="comp-tab-content">
                      {/* Topics Tab */}
                      <div className={`comp-tab-pane ${activeTabs[comp.id] === "topics" ? "active" : ""}`}>
                        <h4>Topics (Choose one)</h4>
                        <table className="info-table">
                          <tbody>
                            {comp.topics.map((topic, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{topic}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Criteria Tab */}
                      <div className={`comp-tab-pane ${activeTabs[comp.id] === "criteria" ? "active" : ""}`}>
                        <h4>Judgment Criteria</h4>
                        <table className="info-table">
                          <tbody>
                            {comp.criteria.map((item, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{item}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Details Tab */}
                      <div className={`comp-tab-pane ${activeTabs[comp.id] === "details" ? "active" : ""}`}>
                        <h4>Submission Details</h4>
                        <table className="info-table">
                          <tbody>
                            {comp.details.map((item, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{item}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="contact-section mt-5">
            {/*  <h3>Contact Us</h3>
            <p>For any queries regarding the events or submission process, feel free to reach out to us.</p> */}

            <div className="mt-4">
              {/* <a href="https://forms.office.com/r/CvPHdcmsMd" className="register-button" target="_blank" rel="noopener noreferrer">
                Submission Link
              </a>{" "} */}
              <a href="https://chat.whatsapp.com/EpHthYp5Ewc3N6qkNOQJ2T" className="register-button" target="_blank" rel="noopener noreferrer">
                Join WhatsApp Group (Teacher Incharges Only)
              </a>
            </div>

            <div className="contact-email">
              Email: <a href="mailto:B.loshali@chinmayavvdelhi.ac.in">B.loshali@chinmayavvdelhi.ac.in</a>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
